import { API_REQUEST } from ".";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  allAssetsAPI,
  assetDetailAPI,
  homeAssetsAPI,
  publicAssetsAPI,
  userDetailAPI,
} from "../../routes/apiURL";

// fetch-all-assets
export const fetchAllAssets = createAsyncThunk(
  "fetch-all-assets",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: allAssetsAPI,
        method: "GET",
        params: props || {},
      });
      return response;
    } catch (error) {}
  },
);

// fetch-assets-detail
export const fetchAssetsDetail = createAsyncThunk(
  "fetch-assets-detail",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: assetDetailAPI + props,
        method: "GET",
      });
      return response;
    } catch (error) {}
  },
);
// fetch-user-detail
export const fetchUserDetail = createAsyncThunk(
  "fetch-user-detail",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: userDetailAPI + props,
        method: "GET",
      });
      return response;
    } catch (error) {}
  },
);

// fetch-public-assets
export const fetchPublicAssets = createAsyncThunk(
  "fetch-public-assets",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: publicAssetsAPI,
        method: "GET",
        params: props || {},
      });
      return response;
    } catch (error) {}
  },
);

// fetch-home-assets
export const fetchHomeAssets = createAsyncThunk(
  "fetch-home-assets",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: homeAssetsAPI,
        method: "GET",
        params: props || {},
      });
      return response;
    } catch (error) {}
  },
);